import React from 'react';
import { useAuth } from '../contexts/AuthContext.jsx';
import { goContextualBack } from '../contextualBack.js';
import { useNavigate } from 'react-router-dom';

export function canManageJuniorCampaign(user, type) {
  return Array.isArray(user?.junior_campaign_types) && user.junior_campaign_types.includes(type);
}

export default function JuniorCampaignAccess({ type, children }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  if (canManageJuniorCampaign(user, type)) return children;
  return <main style={{ maxWidth: 760, margin: '40px auto', padding: 24 }}>
    <h1>Campagne junior</h1>
    <p>Le pilotage de cette campagne est réservé à la supervision, depuis le secteur concerné.</p>
    <button type="button" onClick={() => goContextualBack(navigate)}>Retour</button>
  </main>;
}
